import React, {} from 'react';
import { useAppSelector } from '../_library';

const ROLE_ORDER = ['accountant_readonly', 'accountant', 'manager', 'owner'];

export const checkUserAccess = (role: string, minimalRole: string = 'accountant_readonly'): boolean => {
    const userRoleIndex = ROLE_ORDER.indexOf(role);
    const minimalRoleIndex = ROLE_ORDER.indexOf(minimalRole);

    if (userRoleIndex === -1) return false;
    if (minimalRoleIndex === -1) return false;
    
    return userRoleIndex >= minimalRoleIndex; 
};

type Props = {
    children: React.ReactNode,
    minimalRole?: string
};

export const CanAccess = ({ children, minimalRole = 'accountant_readonly'}: Props) => {
    const { role } = useAppSelector(state => state.user);

    const userRoleIndex = ROLE_ORDER.indexOf(role);
    const minimalRoleIndex = ROLE_ORDER.indexOf(minimalRole);

    if (userRoleIndex === -1) return null;
    if (minimalRoleIndex === -1) return null;
    if (userRoleIndex < minimalRoleIndex) return null; 
    
    return children;
};